import fetchWrapper from "@/api/fetch-wrapper";

export const getAutoInfo = (regNums, code, isTest) => {
    const isTestRequest = isTest ? 'Y' : 'N';
    const regsString = encodeURI(JSON.stringify(regNums));
    const query = `ajax/autoData.php?regNums=${regsString}&code=${code}&isTest=${isTestRequest}`;
    return fetchWrapper.get(query)
}